export const updateState = (oldState, updatedProperties) => ({
  ...oldState,
  ...updatedProperties,
});
